import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import Footer from "../components/Layout/Footer";
import Header from "../components/Layout/Header";
import Loader from "../components/Layout/Loader";
import ProductCard from "../components/Route/ProductCard/ProductCard";
import styles from "../styles/styles";

const ProductsPage = () => {
  const [searchParams] = useSearchParams();
  const categoryData = searchParams.get("category");
  const {allProducts,isLoading} = useSelector((state) => state.products);
  const [data, setData] = useState([]);
  const [shopName, setShopName] = useState('');

  useEffect(() => {
    // Extract shop name from URL
    const url = window.location.href;

    try {
      const urlObject = new URL(url);
      const formattedUrl = urlObject.hostname.replace("www.", ""); // Remove 'www.' if present
      let extractedShopName = "";

      if (formattedUrl === "localhost") {
        extractedShopName = "redfarma"; // Provide a default shop name for localhost
      } else {
        // Extract the shop name (subdomain)
        extractedShopName = formattedUrl.split(".")[0];
      }

      setShopName(extractedShopName); // Set the extracted shop name
    } catch (error) {
      setShopName("redfarma"); // Fallback shop name if parsing fails
    }
  }, []);

  useEffect(() => {
    // Filter products by shop name and category
    let filteredProducts = allProducts;

    if (allProducts && shopName) {
      filteredProducts = filteredProducts.filter((i) => i.shop.name === shopName);
    }

    if (allProducts && categoryData) {
      filteredProducts = filteredProducts.filter((i) => i.category === categoryData);
    }
    if (filteredProducts){
      filteredProducts = allProducts;
    }
    setData(filteredProducts);
    // console.log("allProducts in ProductsPage.jsx => ", allProducts);
    // console.log("data in ProductsPage.jsx => ", data);
    // console.log("shopName => ", shopName);
  }, [allProducts, shopName, categoryData]);

  return (
  <>
  {
    isLoading ? (
      <Loader />
    ) : (
      <div>
      <Header activeHeading={3} />
      <br />
      <br />
      <div className={`${styles.section}`}>
        <div className="grid grid-cols-1 gap-[20px] md:grid-cols-2 md:gap-[25px] lg:grid-cols-4 lg:gap-[25px] xl:grid-cols-5 xl:gap-[30px] mb-12">
          {data && data.map((i, index) => <ProductCard data={i} key={index} />)}
        </div>
        {data && data.length === 0 ? (
          <h1 className="text-center w-full pb-[100px] text-[20px]">
            No products Found!
          </h1>
        ) : null}
      </div>
      <Footer />
    </div>
    )
  }
  </>
  );
};

export default ProductsPage;
